import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrograms } from '../../src/actions/programs';
import Header from '../../src/components/Header';
import Layout from '../../src/components/Layout';
import ScheduleContainer from '../../src/components/Pages/ScheduleContainer';
import PageLoader from 'components/PageLoader';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';

const Schedule = () => {
  const dispatch = useDispatch();
  const { all: programs, loading: programsLoading } = useSelector(state => state.programs);
  const isLoading = programsLoading;

  useEffect(() => {
    if (!programs?.length) {
      dispatch(fetchPrograms());
    }
  }, [dispatch, programs?.length]);

  return (
    <SessionAuth>
      <Layout title="Schedule | GMB Fitness™">
        <Header />
        {isLoading ? <PageLoader /> : <ScheduleContainer />}
      </Layout>
    </SessionAuth>
  );
};

export default Schedule;
